import React from 'react';
import '../styles/MapModeToggle.css';
import { Button } from '../components';
import { HugeiconsIcon } from '@hugeicons/react';
import { GlobalIcon, RoadWaysideIcon } from '@hugeicons/core-free-icons';
import { colour } from '../styles/GlobalStyles';

function MapModeToggle(props) {
    const toggleSatellite = props.toggleSatellite;
    const mapType = props.mapType;
    return (
        <div className="map-mode-toggle-container">
            <Button
                buttonType={mapType === "roadmap" ? "primary-button" : "light-button"}
                size="x-small"
                text={mapType === "roadmap" ? "Satellite view" : "Road view"}
                cta={toggleSatellite}
                disabled={false}
                leftIcon={mapType === "roadmap" ? <HugeiconsIcon icon={GlobalIcon} color={colour.gray00} size={14} /> : <HugeiconsIcon icon={RoadWaysideIcon} color={colour.gray06} size={14} />}
                leftIconClass=""
                rightIcon={null}
                rightIconClass=""
                alt=""
                standardIcon={false}
                badge={false}
                badgeVal={null}
                badgeBG={null}
                buttonRef={null}
                spinner={false}
            />
        </div>
    )
};

export default MapModeToggle;